// export const API = 'http://localhost:4000/api';
// export const API = 'https://9c53s051-3000.inc1.devtunnels.ms/api';
// export const API = 'http://52.66.255.130:4000/api'; //PROJECT NAMED "Lexile project"
// lexile speech hosted url 
// export const API = 'https://sajskanpur.in/api';  //PROJECT NAMED "Lexile-speech" 13.203.104.179
// export const API = 'http://13.201.72.39:4000/api';  //PROJECT NAMED "Lexile-partner-school" 13.201.72.39
// export const API = 'http://65.0.185.61:4000/api';  //PROJECT NAMED "Lexile-speech-orden"
// export const API = 'https://lexilearn.in/api';  //PROJECT NAMED "Lexile-speech-orden"new
// export const API = 'http://13.126.21.185:4000/api';  //PROJECT NAMED "Lexile demo new" on society orden technical services
// export const API = 'https://demo.lexilearn.in/api';  //PROJECT NAMED "Lexile demo new" on orden technical services
export const API = 'https://srj.lexilearn.in/api';  //PROJECT NAMED "Lexile partner schools" on srj aws

